import { useCCTM, useModel, useParams, useRoute } from "@bcm-dev/bcms-vite";
import React, { useEffect, useRef, useState } from "react";

import "./styles.css";

import Util from "classes/Util";
import BottomNavView from "components/shared/views/BottomNavView";

/**
 * @function BottomNavWrapper 
 * @returns {React.Component}
 * @exported true
 * @description This is the iframe wrapper that will pull in ABI22 and show the BottomNavView component.
 */
export default function BottomNavWrapper(props) {
  const [src, setSrc]  = useState({route:props.page,key:Date.now()});
  const { b,c, branding } = useModel();
  const {footer} = useParams();
  const ref = useRef();
  const course = branding.options.abi22_courseid_mabi23;
 const xml = useCCTM();

  let nav = useRoute();
  const [ hideNav, setHideNav ] = useState(props.hideNav ?? footer === "noFooter" ? true : false); 
  const origin =  window.location.origin.indexOf("localhost") !== -1 ?`http://${window.location.hostname}:${parseInt(window.location.port)+1}` :window.location.origin+`${window.location.pathname.replace("mabi23","abi22")}?b=${ b }&c=${ course }`;
  const iframeSrc = `${ origin}/#/${props.page}`;
  
  const refreshFrame = (route)=>{

  
   nav(`/content/${route}`)
      ref.current.contentWindow.postMessage({message:"force-global-route",detail: {
      route: `/${route}`
    }   },"*");
    
 
    }   

document.loadFrame = function() {

if(document.demoLoaded === undefined) {
  document.demoLoaded = iframeSrc;
  window.parent.document.loadFrame();
}

  ref.current.setAttribute("abi22","true");
} 


window.addEventListener("message", evt => {
  if(evt.data.message === "force-global-route"){
   const { route, state } = evt.data.detail;
   let newSrc ={route:route,key:Date.now()}; 
  
      
    nav(route)
  
 
  }
});

  // START: Sets abi22 custom font throughout the demo, except the mabi23 login pages.
  const [ abi22Branding, setABI22Branding ] = useState(Util.getABI22Branding())
  const options = abi22Branding ? abi22Branding.options : {};
  let abi22ClassName = "";
  const abi22CustomFont = options.custom_font_abi22;
  let abi22CustomFontClass = "";
  const hasABI22CustomFont = (abi22CustomFont === "undefined" || abi22CustomFont === "Default" || abi22CustomFont === undefined) ? false : true;

  if(hasABI22CustomFont) {
    abi22CustomFontClass = `${ abi22CustomFont.toLowerCase() }-font`;
    abi22ClassName = `${ abi22ClassName } ${ abi22CustomFontClass }`;
  }
  // END: Sets abi22 custom font throughout the demo, except the mabi23 login pages.

useEffect(() => {
  // START: Set event listeners then remove them on component unmount
  // to prevent multiple listeners from being set.
  // Issue occurs with "ad" click events being called mulitiple times in the child abi22 iframe.
  const abi22IframeDidLoad = evt => {
    var mabiStyles = document.getElementsByTagName("style");
   var mabi23BrandingStyles = Object.keys(mabiStyles).reduce(function(res,index){
          var elem = mabiStyles[index];
          if(res === null){
            return elem.innerHTML.indexOf("Templated Strings CSS File") !== -1 ? elem : res;
          }else{
            return res;
          }

        },null)  
    if(evt.data.message === "abi22-iframe-did-load") {
      const serializer = new XMLSerializer();

      const abi22Branding = evt.data.abi22Branding ?? {};
      window.abi22Branding = abi22Branding;
      setABI22Branding(window.abi22Branding);
      
      const message = { 
        message: {
          mabi23Branding: { ...branding },
          "mabi23BrandingStyles":mabi23BrandingStyles.innerHTML,

          mabiMenu:serializer.serializeToString(xml)
          
        } 
      };
      ref.current.contentWindow.postMessage(message, "*");
    }
  };
  // Function that listens to a message from CH21 integrated in ABI22. 
  // That CH21 instance exists in an iframe in component "ABI22PageIframeView"
  // which is different than the ABI22 iframe returned below.
  const closeABI22MobileMenu = evt => {
    if(evt.data.message === "closeABI22MobileMenu") {
        ref.current.contentWindow.postMessage({ message: "closeABI22MobileMenu" }, "*")
    }
  }

  // Function that listens to a message from abi22 to hide/show the bottom nav.
  // It is needed in the "Deposits" workflow where the camera view needs
  // to take up the entire screen view.
  const hideMABI23BottomNav = evt => {
    const message = evt.data.message;

    if(message) {
      if(message.hideMABI23BottomNav) {
        setHideNav(message.hideMABI23BottomNav === "true");
      }
    }
  }
    
  window.addEventListener("message", abi22IframeDidLoad);
  window.addEventListener("message", closeABI22MobileMenu);
  window.addEventListener("message", hideMABI23BottomNav);

  // END: Set event listeners then remove them on component unmount
  // to prevent multiple listeners from being set.
  // Issue occurs with "ad" click events being called mulitiple times in the child abi22 iframe.

  return () => {
    window.removeEventListener("message", abi22IframeDidLoad);
    window.removeEventListener("message", closeABI22MobileMenu);
    window.removeEventListener("message", hideMABI23BottomNav);
  };
}, []);

  return (
    <div className={`bottom-nav-wrapper ${hideNav ?"no-nav":""} ${ abi22ClassName }`}>
      <iframe key ={src.key} ref={ref} title="Bottom Nav Wrapper" src={ iframeSrc } />
      {!hideNav && <BottomNavView  setSrc = {refreshFrame} src={iframeSrc}/>}
   </div>
  );
}